var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('b-alert',{attrs:{"variant":"danger","show":""}},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e(),_c('universal-uploader',{staticClass:"text-truncate",on:{"uploadSuccess":_vm.uploadPhotoSuccess}},[_c('b-btn',{attrs:{"pill":"","variant":"primary","size":"lg","block":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }